import {graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {
	CreateDateEffectiveExchangeRatesInput,
	CreateExchangeRateBatchMutation,
} from './__generated__/CreateExchangeRateBatchMutation.graphql';

const mutation = graphql`
	mutation CreateExchangeRateBatchMutation($input: CreateDateEffectiveExchangeRatesInput!) {
		createDateEffectiveExchangeRates(input: $input) {
			company {
				id
				exchangeRates(first: 10000) @connection(key: "Company_exchangeRates") {
					edges {
						node {
							id
							currency
							rate
							startDate
							endDate
							isUsed
							createdAt
						}
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateDateEffectiveExchangeRatesInput,
	onSuccess?: (response: CreateExchangeRateBatchMutation['response']) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<CreateExchangeRateBatchMutation>(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				currency: input.currency,
				rates: input.rates,
			},
		},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
